export const GET_QUESTIONS_REQUEST = 'GET_QUESTIONS_REQUEST';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';
export const GET_QUESTIONS_FAILURE = 'GET_QUESTIONS_FAILURE';
export const UPDATE_QUESTION_STATUS_REQUEST = 'UPDATE_QUESTION_STATUS_REQUEST';
export const UPDATE_QUESTION_STATUS_SUCCESS = 'UPDATE_QUESTION_STATUS_SUCCESS';
export const UPDATE_QUESTION_STATUS_FAILURE = 'UPDATE_QUESTION_STATUS_FAILURE';
export const CREATE_QUESTION_REQUEST = 'CREATE_QUESTION_REQUEST';
export const CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS';
export const CREATE_QUESTION_FAILURE = 'CREATE_QUESTION_FAILURE';
export const UPDATE_QUESTION_REQUEST = 'UPDATE_QUESTION_REQUEST';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE';
export const DELETE_QUESTION_REQUEST = 'DELETE_QUESTION_REQUEST';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_FAILURE = 'DELETE_QUESTION_FAILURE';


export const getQuestionsRequest = (data) => ({
  type: GET_QUESTIONS_REQUEST,
  payload: data,
});

export const getQuestionsSuccess = (data) => ({
  type: GET_QUESTIONS_SUCCESS,
  payload: data,
});

export const getQuestionsFailure = (error) => ({
  type: GET_QUESTIONS_FAILURE,
  payload: error,
});

export const updateQuestionStatusRequest = (data) => ({
  type: UPDATE_QUESTION_STATUS_REQUEST,
  payload: data,
});

export const updateQuestionStatusSuccess = (data) => ({
  type: UPDATE_QUESTION_STATUS_SUCCESS,
  payload: data,
});

export const updateQuestionStatusFailure = (error) => ({
  type: UPDATE_QUESTION_STATUS_FAILURE,
  payload: error,
});

export const createQuestionRequest = (data) => ({
  type: CREATE_QUESTION_REQUEST,
  payload: data,
});

export const createQuestionSuccess = (data) => ({
  type: CREATE_QUESTION_SUCCESS,
  payload: data,
});

export const createQuestionFailure = (error) => ({
  type: CREATE_QUESTION_FAILURE,
  payload: error,
});

export const updateQuestionRequest = (data) => ({
  type: UPDATE_QUESTION_REQUEST,
  payload: data,
});

export const updateQuestionSuccess = (data) => ({
  type: UPDATE_QUESTION_SUCCESS,
  payload: data,
});

export const updateQuestionFailure = (error) => ({
  type: UPDATE_QUESTION_FAILURE,
  payload: error,
});

export const deleteQuestionRequest = (data) => ({
  type: DELETE_QUESTION_REQUEST,
  payload: data,
});

export const deleteQuestionSuccess = (data) => ({
  type: DELETE_QUESTION_SUCCESS,
  payload: data,
});

export const deleteQuestionFailure = (error) => ({
  type: DELETE_QUESTION_FAILURE,
  payload: error,
});